<template>
	<div>
		<!-- logo 时间 -->
		<q-head></q-head>
		<!-- banner -->
		<qBanner></qBanner>




		<div class="read">
			<div class="read-hd">
				<q-title title="自助核酸" time="86"></q-title>
				<q-step :step="3"></q-step>
			</div>

			<div class="user-info-row fcc">
				<div>
					<span>姓名：</span>
					<b>张三</b>
				</div>
				<div>
					<span>性别：</span>
					<b>男</b>
				</div>
				<div>
					<span>身份证号码：</span>
					<b>360************131</b>
				</div>
			</div>

			
			<div class="nucleic-acid-list">
				<div class="item" :class="{on : tabindex1==true}" @click="tabindex1=!tabindex1">
					<div class="col1">
						<img src="../../assets/icon/icon-check3.png" v-if="tabindex1">
						<img src="../../assets/icon/icon-check.png" v-else>
					</div>
					<div class="col2">
						新型冠状病毒核酸检测（咽拭子） 
					</div>
					<div class="col3">
						￥60元
					</div>
					<div class="col4">
						<i class="el-icon-arrow-right"></i>	
					</div>
				</div>
				<div class="item" :class="{on : tabindex2==true}" @click="tabindex2=!tabindex2">
					<div class="col1">
						<img src="../../assets/icon/icon-check3.png" v-if="tabindex2">
						<img src="../../assets/icon/icon-check.png" v-else>
					</div>
					<div class="col2">
						新型冠状病毒抗体IgG/IgM检测
					</div>
					<div class="col3">
						￥60元
					</div>
					<div class="col4">
						<i class="el-icon-arrow-right"></i>	
					</div>
				</div>
			</div>
				
			
			<div class="statementToRemind">
				<div class="txt">
					<h3>
						自助开单声明提醒
					</h3>
					<p>
						本项目是方便患者提供新冠肺炎核酸检测而设
						注意：以下两点请务必仔细阅读<br>
						1、您无发热（体温≥37.3℃）和/或呼吸道症状。<br>
						2、您是健康码“绿码”者。<br>
						以上两点承诺真实可信，如因个人主观原因漏报、
						瞒报、虚报造成相关后果，本人愿意
						承担相应法律责任。
					</p>
				</div>
				<div class="img">
					<img src="../../assets/hesuan.png" >
				</div>
			</div>	
			
			

			<div class="foot-buttons fc-bet">
				<a href="/" class="btn-home fcc">
					<img src="../../assets/icon/icon-home.png">
					<span>首页</span>
				</a>
				<a class="btn-pay fcc" @click="enter">
					<img src="../../assets/icon/icon-ok.png" >
					<span>确认</span>
				</a>	
				<a class="btn-return fcc" @click="returnStep()">
					<img src="../../assets/icon/icon-return.png">
					<span>返回</span>
				</a>
			</div>

		</div>

	</div>
</template>

<script>
	import qHead from '@/components/q-head/q-head.vue';
	import qBanner from '@/components/q-head/q-banner.vue';
	import qTitle from '@/components/q-read/q-title.vue';
	import qStep from '@/components/q-read/q-step.vue';

	export default {
		components: {
			qHead,
			qBanner,
			qStep,
			qTitle
		},
		data() {
			
			return {
				tabindex1:false,
				tabindex2:false
			}
		},
		mounted() {
			
		},
		methods: {
			enter(){
				this.openUrl('/nucleic-acid2')
			}
		},
		beforeDestroy() {
			//clearInterval(this.timer);
		}

	}
</script>

<style  lang="less">

		
	
</style>
